import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Table, Button } from 'react-bootstrap';
import ModuleHeader from '../../components/ModuleHeader';
import { orderUploadOperations } from "./state";
import TableTemplate from '../../components/TableTemplate';
import { ORDER_UPLOAD } from '../BPOrder/routes';

class OrderUploadDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.props.location.state && this.props.location.state.record
        };
    }

    componentWillMount() {
        this.props.fetchDefault({ riyoKigyoId: this.props.riyoKigyoId }, this.props.match.params.historyNo)
    }

    uploadDetails = () => {
        return (
            <div className="extra-text2">
                <Table bordered>
                    <thead>
                        <tr>
                            <th className="table-header ">履歴No</th>
                            <th className="table-header">アップロード日時</th>
                            <th className="table-header">件数</th>
                            <th className="table-header">エラー</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="text-right">{this.state.uploadNo}</td>
                            <td>{this.state.uploadDttmDisplay}</td>
                            <td className="text-right">{this.state.countDisplay}</td>
                            <td className="text-right">{this.state.errorDisplay}</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        )
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <ModuleHeader title={"受注データアップロード結果表示"} />
                    
                    {this.uploadDetails()}

                    <br />
                    <TableTemplate
                        specialRow={{ field: "errorCd", greaterThan: true, value: 0, color: "#f5c6cb" }}
                        hasError={this.props.tableList.filter(row => row.errorCd > 0).length > 0 ? true : false}
                        {...this.props}
                    />

                    <br />
                    <Button
                        className="button-filter list-button"
                        onClick={() => this.props.history.push(ORDER_UPLOAD)}
                    >
                        戻る
                </Button>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        riyoKigyoId: state.auth.credentials.riyo_kigyo_id,
        isAuthenticated: state.auth.isAuthenticated,
        tableHeader: state.orderUpload.tableViewHeader,
        tableList: state.orderUpload.viewList,
        tableColumns: state.orderUpload.tableViewColumns,
    }
};

const mapDispatchToProps = {
    fetchDefault: orderUploadOperations.fetchDetailsList,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderUploadDetails);